import type { VoidFunctionComponent } from 'react';

import type { CheckRevisionResponse } from '../../../../../shared/revisions/types';

import IndeterminateGit from './IndeterminateGit';
import Invalid from './Invalid';
import Loading from './Loading';
import Metadata from './Metadata';

import styles from './index.module.less';

type Props = {
  metadata?: CheckRevisionResponse;
  isLoading?: boolean;
  isIndeterminate?: boolean;
  isInvalid?: boolean;
};

const TestDependencyCardContent: VoidFunctionComponent<Props> = ({
  metadata,
  isLoading,
  isIndeterminate,
  isInvalid,
}) => {
  if (isLoading) {
    return <Loading />;
  }

  if (isIndeterminate) {
    return <IndeterminateGit />;
  }

  if (isInvalid || !metadata) {
    return <Invalid />;
  }

  return <Metadata metadata={metadata} />;
};

/**
 * A multi-state card component used to display the results of testing if a
 * dependency revision has been resolved (or can be resolved) by FOSSA.
 */
const TestDependencyCard: VoidFunctionComponent<Props> = ({ metadata, isLoading, isIndeterminate, isInvalid }) => {
  return (
    <div className={styles.card}>
      <TestDependencyCardContent
        metadata={metadata}
        isLoading={isLoading}
        isIndeterminate={isIndeterminate}
        isInvalid={isInvalid}
      />
    </div>
  );
};

export default TestDependencyCard;
